export const tr = {
    'vcard-city-letters': 'Şehir adında sadece harfler kullanılmalıdır',
    'vcard-city-max-length': 'Şehir adı {maxLength} karakterden uzun olamaz',
    'vcard-city-no-empty': 'Şehir belirtin',
    'vcard-country-letters': 'Ülke adında sadece harfler kullanılmalıdır',
    'vcard-country-max-length': 'Ülke adı {maxLength} karakterden uzun olamaz',
    'vcard-country-no-empty': 'Ülke belirtin',
    'vcard-descr-format': 'Açıklamada sadece harfler, sayılar ve noktalama işaretleri kullanılabilir',
    'vcard-descr-max-length': 'Açıklama {maxLength} karakterden uzun olamaz',
    'vcard-descr-no-empty': 'Açıklama girin',
    'vcard-error-text': 'Beklenmeyen bir hata oluştu: {code}/{code}. Daha sonra tekrar deneyin',
    'vcard-house-max-length': 'Bina numarası {maxLength} karakteri aşmamalıdır',
    'vcard-house-no-empty': 'Bina numarasını belirtin',
    'vcard-mail-format': 'E-posta adresi formatı hatalı',
    'vcard-mail-max-length': 'E-posta adresi {maxLength} karakterden uzun olamaz',
    'vcard-mail-no-empty': 'E-posta adresini girin',
    'vcard-messenger-icq-format': 'ICQ kullanıcı adı formatı hatalı',
    'vcard-messenger-jabber-format': 'JABBER kullanıcı adı formatı hatalı',
    'vcard-messenger-login-length': 'Kullanıcı adı {maxLength} karakterden uzun olamaz',
    'vcard-messenger-mailruagent-format': 'Mail.Ru kullanıcı adı formatı hatalı',
    'vcard-messenger-skype-or-msn-format': 'Kullanıcı adı formatı hatalı',
    'vcard-name-letters': 'İsimde sadece harfler, sayılar ve noktalama işaretleri kullanılabilir',
    'vcard-name-max-length': 'İsim {maxLength} karakterden uzun olamaz',
    'vcard-name-no-empty': 'Şirket adını belirtin',
    'vcard-need-to-save': 'Reklamı kaydetmeden önce kartvizitin düzenlenmesini tamamlayın',
    'vcard-office-format': 'Ofisi belirtmek için sadece harfler, rakamlar ve noktalama işaretleri kullanın',
    'vcard-office-max-length': 'Bu alan {maxLength} karakteri aşamaz',
    'vcard-office-no-empty': 'Ofis belirtin',
    'vcard-ogrn-format': 'Hatalı OGRN/OGRNIP formatı',
    'vcard-ogrn-no-empty': 'OGRN/OGRNIP belirtin',
    'vcard-phone-city-code-format': 'Şehir kodu formatı hatalı',
    'vcard-phone-city-code-length': 'Şehir kodu {maxLength} karakterden uzun olamaz',
    'vcard-phone-city-code-no-empty': 'Şehir kodunu belirtin',
    'vcard-phone-country-code-format':
        'Ülke kodu "+" işareti ile başlamalı ve 1 ila 4 haneli olmalıdır. Ayrıca "800" bölge kodu ile birlikte "8" ile başlayan ülke kodu da kullanılabilir.',
    'vcard-phone-country-code-length': 'Ülke kodu {maxLength} karakterden uzun olamaz',
    'vcard-phone-country-code-no-empty': 'Ülke kodunu belirtin',
    'vcard-phone-country-code-start-no-plus':
        'Ülke kodunda "8" veya "0" değerleri kullanılabilir. Bölge kodu ile birlikte "8 800", "8 804" ve "0 800" değerleri de belirtilebilir.',
    'vcard-phone-country-code-start-plus': 'Ülke kodunun önünde "+" işareti kullanın',
    'vcard-phone-extension-format': 'Dahili numara formatı hatalı',
    'vcard-phone-extension-max-length': 'Dahili numara {maxLength} karakterden uzun olamaz',
    'vcard-phone-number-format': 'Telefon numarası formatı yanlış',
    'vcard-phone-number-max-length': 'Telefon numarası {maxLength} karakterden uzun olamaz',
    'vcard-phone-number-min-length': 'Telefon numarası {minLength} karakterden kısa olamaz',
    'vcard-phone-number-no-empty': 'Telefon numarasını belirtin',
    'vcard-street-letters': 'Sokak adında sadece harfler, sayılar ve noktalama işaretleri kullanılabilir',
    'vcard-street-max-length': 'Sokak adı {maxLength} karakterden uzun olamaz',
    'vcard-street-no-empty': 'Sokak adı girin'
};
